import { ref } from 'vue';

/**
 * Module-scoped so every trigger drives the same window.
 *
 * The brand header exists twice — `header-brand-account` for desktop and
 * `headerMobile` for everything below it — and a button in each is the only way
 * to appear in both. A ref inside the composable would give each its own state,
 * and a panel inside each button would start the plugin twice over.
 */
const isOpen = ref(false);

export const useBrandAssistant = () => {
  const toggle = (): void => {
    isOpen.value = !isOpen.value;
  };

  return { isOpen, toggle };
};
